module.exports = __webpack_public_path__ + "static/media/Fast.6e7e7bdc.png";